import * as React from "react";
import type { SVGProps } from "react";
const SvgIntagramNegative = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      fill="#1D1D1D"
      d="M10.017 6.133a3.85 3.85 0 0 0-3.85 3.85 3.83 3.83 0 0 0 3.85 3.85c2.11 0 3.85-1.707 3.85-3.85 0-2.11-1.74-3.85-3.85-3.85m0 6.361a2.51 2.51 0 0 1-2.511-2.51c0-1.374 1.104-2.478 2.51-2.478a2.47 2.47 0 0 1 2.478 2.477c0 1.406-1.104 2.511-2.477 2.511M14.905 6a.9.9 0 0 0-.904-.904.9.9 0 0 0-.904.904.9.9 0 0 0 .904.904.9.9 0 0 0 .904-.904m2.545.904c-.067-1.205-.335-2.277-1.206-3.147-.87-.871-1.941-1.139-3.147-1.206-1.239-.067-4.955-.067-6.194 0-1.205.067-2.243.335-3.147 1.206-.871.87-1.139 1.942-1.206 3.147-.067 1.239-.067 4.955 0 6.194.067 1.206.335 2.243 1.206 3.147.904.871 1.942 1.139 3.147 1.206 1.239.067 4.955.067 6.194 0 1.206-.067 2.277-.335 3.147-1.206.871-.904 1.139-1.941 1.206-3.147.067-1.239.067-4.955 0-6.194m-1.607 7.5c-.235.67-.77 1.172-1.407 1.44-1.004.401-3.348.301-4.42.301-1.104 0-3.448.1-4.419-.301a2.54 2.54 0 0 1-1.44-1.44c-.401-.971-.301-3.315-.301-4.42 0-1.071-.1-3.415.301-4.42a2.58 2.58 0 0 1 1.44-1.406c.971-.401 3.315-.301 4.42-.301 1.071 0 3.415-.1 4.42.301.636.235 1.138.77 1.406 1.407.401 1.004.301 3.348.301 4.42 0 1.104.1 3.448-.301 4.419"
    />
  </svg>
);
export default SvgIntagramNegative;
